var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAdd = function SvgIconAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-add_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-add_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M9.25 10.75h-3.5a.728.728 0 0 1-.534-.214.72.72 0 0 1-.216-.532c0-.21.072-.39.216-.535a.72.72 0 0 1 .534-.219h3.5v-3.5c0-.213.071-.39.214-.534A.72.72 0 0 1 9.996 5c.21 0 .39.072.535.216a.72.72 0 0 1 .219.534v3.5h3.5c.213 0 .39.071.534.214a.72.72 0 0 1 .216.532c0 .21-.072.39-.216.535a.72.72 0 0 1-.534.219h-3.5v3.5a.73.73 0 0 1-.214.534.72.72 0 0 1-.532.216.734.734 0 0 1-.535-.216.72.72 0 0 1-.219-.534v-3.5Z"
  }))));
};
export default SvgIconAdd;